import { Get } from '../helpers';

const GetGreenroomMeetingFeatureFlags = (meetingId: number): Promise<Record<string, boolean> | null> => {
  return Get({
    host: import.meta.env.VITE_GREENROOM_API,
    url: `/v2/greenroom/feature-flag-overrides/meeting/${meetingId}`,
    includeBlToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default GetGreenroomMeetingFeatureFlags;
